import React from 'react';
import { FileDown, History, Percent, Plus, Upload } from 'lucide-react';
import IconTitle from './IconTitle';
import { Button } from '@/components/ui/button';
import type { LucideIcon } from 'lucide-react';
import SearchAndFilter from './SearchAndFilter';
import { Link } from 'react-router';
interface TableHeaderProps {
  title: string;
  titleIcon: LucideIcon;
  searchPlaceholder?: string;
  onAddButtonClick?: () => void;
  addButtonText?: string;
  showSearch?: boolean;
  onViewAllButtonClick?: () => void;
  className?: string;
  onAddMarkupClick?: () => void;
  onImportProductsClick?: () => void;
  onImportHistoryClick?: () => void;
  onExportButtonClick?: () => void;
  extraOptions?: any;
}

const TableHeader: React.FC<TableHeaderProps> = ({
  title,
  titleIcon,
  onAddButtonClick,
  addButtonText = 'Add Data',
  searchPlaceholder,
  showSearch = false,
  onViewAllButtonClick,
  className = '',
  onAddMarkupClick,
  onImportProductsClick,
  onImportHistoryClick,
  onExportButtonClick,
  extraOptions,
}) => {
  const addQrPrintLink = extraOptions?.addQrPrintLink;

  return (
    <div className={`d-fc-header mb-3 flex justify-between gap-2 overflow-auto pb-1 ${className}`}>
      <div className="left-col">
        <IconTitle title={title} icon={titleIcon} />
      </div>
      <div className="right-col flex items-center gap-4">
        {showSearch && (
          <div className="search-and-filder">
            <SearchAndFilter placeholder={searchPlaceholder} />
          </div>
        )}
        {onImportHistoryClick && (
          <Button variant="iconButtonMuted" onClick={onImportHistoryClick}>
            <History />
            Import History
          </Button>
        )}
        {onImportProductsClick && (
          <Button variant="iconButtonMuted" onClick={onImportProductsClick}>
            <FileDown />
            Import Products
          </Button>
        )}
        {onAddMarkupClick && (
          <Button variant="iconButtonMuted" onClick={onAddMarkupClick}>
            <Percent />
            Add Markup
          </Button>
        )}

        {onAddButtonClick &&
          (addButtonText === 'Add to Print Queue' && addQrPrintLink ? (
            <Link to={addQrPrintLink}>
              <Button variant="iconButton" onClick={onAddButtonClick}>
                <Plus />
                {addButtonText}
              </Button>
            </Link>
          ) : (
            <Button variant="iconButton" onClick={onAddButtonClick}>
              <Plus />
              {addButtonText}
            </Button>
          ))}

        {onExportButtonClick && (
          <Button variant="iconButton" onClick={onExportButtonClick}>
            <Upload />
            Export
          </Button>
        )}

        {onViewAllButtonClick && (
          <Button variant="iconButton" onClick={onViewAllButtonClick}>
            View All
          </Button>
        )}
      </div>
    </div>
  );
};

export default TableHeader;
